import React from 'react'
import {Field} from 'formik'

import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

import InputSelect from '../../../../designSystem/InputSelect'
import InputWrapperFormik from '../../../../designSystem/InputWrapperFormik'

import {CurrencyType} from '@daedalus/core/src/localization/types/CurrencyType'

interface Props {
  /** The id of the field */
  fieldId: string
  /** List of currencies */
  currenciesList: CurrencyType[]
  /** List of popular currencies */
  popularCurrenciesList: CurrencyType[]
  /** Callback that fires when the select is clicked */
  onClick?: () => void
}

const Option = ({currency}: {currency: CurrencyType}) => {
  return (
    <option key={currency.code} value={currency.code}>
      {currency.displayName} ({currency.code})
    </option>
  )
}

export const CurrencySelect = ({
  fieldId,
  currenciesList,
  popularCurrenciesList,
  onClick
}: Props) => {
  return (
    <InputWrapperFormik Field={Field} name={fieldId}>
      <InputSelect
        withChevron
        withBorder
        withValidationIcon={false}
        dataId="PreferencesPopup-currency"
        id={fieldId}
        placeholder={
          <FormattedMessageWrapper
            id="preferencesPopup.currencySelect.placeholder"
            defaultMessage="Currency"
          />
        }
        onClick={onClick}
      >
        <optgroup>
          {popularCurrenciesList.map(currency => (
            <Option key={currency.code} currency={currency} />
          ))}
        </optgroup>
        <optgroup label="-----------">
          {currenciesList.map(currency => (
            <Option key={currency.code} currency={currency} />
          ))}
        </optgroup>
      </InputSelect>
    </InputWrapperFormik>
  )
}
